export default function createTargetConnector(backend) {
  return {
    dropTarget: backend.connectDropTarget.bind(backend)
  };
}


/** WEBPACK FOOTER **
 ** ./src/createTargetConnector.js
 **/